import type { Context, Petition, Template } from '../types';

import { useFlyerA } from './useFlyerA';
import { useFlyerB } from './useFlyerB';
import { useFlyerC } from './useFlyerC';

type UseFlyerTemplatesArgs = { petition: Petition; context: Context };
export function useFlyerTemplates({ petition, context }: UseFlyerTemplatesArgs): Template[] {
	const templates = [
		useFlyerA({ petition, context }),
		useFlyerB({ petition, context }),
		useFlyerC({ petition, context }),
	];
	return templates.filter((template) => template.enabled);
}
